﻿/**
 * 全局 z-index 管理器
 * 用于统一管理弹窗、下拉框等需要层级的组件
 *
 * 设计原则：
 * 1. 只递增不递减，避免因未调用销毁方法导致的内存泄漏
 * 2. popup 类型包含 dialog 和 dropdown，它们共用同一层级空间（在 dialog 中可能有 dropdown）
 * 3. 层级优先级：popup(1000) < loading(9000) < toast(10000)
 */
(function(window) {
    'use strict';

    var ZIndexManager = {
        base: {
            popup: 1000,
            loading: 9000,
            toast: 10000
        },

        current: {
            popup: 0,
            loading: 0,
            toast: 0
        },

        next: function(type) {
            if (type === 'dialog' || type === 'dropdown') {
                type = 'popup';
            }
            
            type = type || 'popup';
            
            if (!this.base[type]) {
                console.warn('Unknown z-index type:', type, ', using popup as default');
                type = 'popup';
            }

            this.current[type]++;

            var baseZIndex = this.base[type];
            var offset = this.current[type] * 2;

            return {
                overlay: baseZIndex + offset - 1,
                content: baseZIndex + offset
            };
        },

        getTop: function(type) {
            if (type === 'dialog' || type === 'dropdown') {
                type = 'popup';
            }
            
            type = type || 'popup';
            
            if (!this.base[type]) {
                type = 'popup';
            }

            var baseZIndex = this.base[type];
            var offset = this.current[type] * 2;
            
            return baseZIndex + offset;
        },

        count: function(type) {
            if (type === 'dialog' || type === 'dropdown') {
                type = 'popup';
            }
            
            type = type || 'popup';
            return this.current[type] || 0;
        },

        reset: function() {
            this.current = {
                popup: 0,
                loading: 0,
                toast: 0
            };
        }
    };

    window.ZIndexManager = ZIndexManager;

    window.useZIndex = function(type) {
        return ZIndexManager.next(type);
    };

})(window);
